module.exports = __webpack_public_path__ + "static/sport/icon-200.2f8f4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-200.png
// module id = Jnko
// module chunks = 0